import React from "react";
import Card from "./Card/Card";
import styles from "./GridComponent.module.scss";

interface GridItem {
  icon?: string;
  title: string;
  description?: string; // Опис також необов'язковий
}

interface GridComponentProps {
  title?: string; // Заголовок секції (необов’язковий)
  items: GridItem[]; // Масив карток
  bottomTitle?: string; // Заголовок внизу блоку (необов’язковий)
  bottomText?: string; // Текст внизу блоку (необов’язковий)
}

const GridComponent: React.FC<GridComponentProps> = ({
  title,
  items,
  bottomTitle,
  bottomText,
}) => {
  return (
    <div className="container">
      <div
        className={`sectionContainer sectionContainerWhite bigSection ${
          !title ? styles.noTitle : ""
        }`}
      >
        {/* Якщо title передано, то відображаємо його */}
        {title && (
          <div className="sideP64 titleCont">
            <div className="titleBlock w100">
              <h2
                dangerouslySetInnerHTML={{
                  __html: title, // Використовуємо dangerouslySetInnerHTML для обробки HTML
                }}
              />
            </div>
          </div>
        )}
        <div className={`sectionBlock ${!title ? styles.noTitleBlock : ""}`}>
          <div className={styles.grid}>
            {items.map((item, index) => (
              <Card
                key={index}
                icon={item.icon}
                title={item.title}
                description={item.description} // Якщо description немає, то просто нічого не передається
              />
            ))}
          </div>
        </div>
        {/* Якщо передано або bottomTitle, або bottomText, об'єднуємо їх в один блок */}
        {(bottomTitle || bottomText) && (
          <div className={`sideP64 ${styles.bottomBlock}`}>
            {bottomTitle && (
              <h3 className={styles.bottomTitle}>{bottomTitle}</h3>
            )}
            {bottomText && <p className={styles.bottomText}>{bottomText}</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default GridComponent;
